import { useState } from "react";

const FORMAT_OPTIONS = [
  { value: "pdf", label: "PDF" },
  { value: "docx", label: "DOCX" },
  { value: "json", label: "JSON" },
  { value: "csv", label: "CSV" },
];

export default function ClientExportModal({
  open,
  loading,
  selectedCount,
  totalCount,
  onClose,
  onSubmit,
}) {
  const [scope, setScope] = useState("selected");
  const [format, setFormat] = useState("pdf");

  if (!open) return null;

  const disabledSelected = selectedCount === 0;

  const submit = async (event) => {
    event.preventDefault();
    await onSubmit({ scope, format });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">Klanten exporteren</h3>
        <p className="mt-1 text-sm text-slate-500">
          Geselecteerd: {selectedCount} van {totalCount}
        </p>

        <form onSubmit={submit} className="mt-4 space-y-4">
          <div>
            <p className="mb-2 text-sm font-medium text-slate-700">Selectie</p>
            <label className="mb-2 flex items-center gap-2 text-sm text-slate-700">
              <input
                type="radio"
                name="scope"
                value="selected"
                checked={scope === "selected"}
                onChange={(event) => setScope(event.target.value)}
                disabled={disabledSelected}
              />
              Alleen geselecteerde klanten
            </label>
            <label className="flex items-center gap-2 text-sm text-slate-700">
              <input
                type="radio"
                name="scope"
                value="all"
                checked={scope === "all"}
                onChange={(event) => setScope(event.target.value)}
              />
              Alle klanten
            </label>
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-slate-700">Bestandsformaat</label>
            <select
              value={format}
              onChange={(event) => setFormat(event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            >
              {FORMAT_OPTIONS.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end gap-2 pt-1">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-slate-200 px-4 py-2 text-sm"
              disabled={loading}
            >
              Annuleren
            </button>
            <button
              type="submit"
              className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white"
              disabled={loading || totalCount === 0 || (scope === "selected" && disabledSelected)}
            >
              {loading ? "Exporteren..." : "Exporteren"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
